export const getLabelByField = field => (
	fundsFields.find(f => f.field === field) ? fundsFields.find(f => f.field === field).label : field
);

export const fundsFields = [
  { label: "Owner", field: "OwnerId" },
  { label: "Fund", field: "Name", isVisible: true, isDefault: true },
  { label: "Fund Owner", field: "fund.Owner.Name", isVisible: true },

  { label: "Account Name", field: "Account_Name__r.Name", isVisible: true },
  { label: "Unique Identifier", field: "Unique_Identifier__c", isVisible: true },

  { label: "Fund Type", field: "Fund__c", isVisible: true }, // ✅ FIXED: was missing
  { label: "Type", field: "Type__c", isVisible: true, isDefault: true },
  { label: "Leading Cloud", field: "Leading_Cloud__c", isVisible: true },

  { label: "Related Opportunity", field: "Related_Opportunity__r.Name", isVisible: true },
  { label: "Category", field: "Category__c", isVisible: true, isDefault: true },

  { label: "Amount", field: "Amount__c", isVisible: true, isDefault: true },
  { label: "Related Service", field: "Related_Service__c", isVisible: true },

  { label: "Priority", field: "Priority__c", isVisible: true, isDefault: true },
  { label: "Currency", field: "CurrencyIsoCode", isVisible: true },

  { label: "Due Date", field: "Due_Date__c", isVisible: true, isDefault: true },
  { label: "Status", field: "Status__c", isVisible: true, isDefault: true },

  { label: "Actual Close Date", field: "Actual_Close_Date__c", isVisible: true },
  { label: "Description", field: "Description__c", isVisible: true },

  { label: "Next Step", field: "Next_Step__c", isVisible: true },
  { label: "Next Step Date", field: "Next_Step_Date__c", isVisible: true },
  { label: "Next Step POC", field: "Next_Step_POC__r.Name", isVisible: true },
  { label: "Next Step Owner", field: "Next_Step_Owner__r.Name", isVisible: true },

  { label: "Created By", field: "CreatedBy.Name", isVisible: true },
  { label: "Last Modified By", field: "LastModifiedBy.Name", isVisible: true }
];

export const getDefaultFields = () => fundsFields.filter(f => f.isDefault);
export const getDisplayFields = (isDefault=false,keys = null) => {
  const visibleFields = fundsFields
  .filter(f => f.isVisible)
  .filter(f => isDefault ? f.isDefault : true);

  if (!keys||keys.length==0) return visibleFields;

  return keys
    .map(key => visibleFields.find(f => f.field === key))
    .filter(Boolean);
};
 const dashboardReportFileds =  ['Id', 'Name', 'Category__c', 'Priority__c', 'Type__c', 'Amount__c', 'Status__c', 'Due_Date__c'];
export const getDashboardDisplayFields = (isDefault=false,keys = null,) => {
  const visibleDashboardFields = dashboardReportFileds
    .map(field => fundsFields.find(f => f.field === field))
    .filter(Boolean)
    .filter(f => isDefault ? f.isDefault :true)
    .map(f => ({ ...f, isVisible: true }));

  if (!keys||keys.length==0) return visibleDashboardFields;

  return keys
    .map(key => visibleDashboardFields.find(f => f.field === key))
    .filter(Boolean);
};
